export default __webpack_public_path__ + "static/media/preloader.1d6398d0.gif";